var map = {
	"./amy.png": 1087,
	"./annotated-example-1.png": 1088,
	"./annotated-example-2.png": 1089,
	"./annotated-example-3.png": 1090,
	"./examples-1.png": 1091,
	"./examples-2.png": 1092,
	"./examples-3.png": 1093,
	"./feedback-1.png": 1094,
	"./feedback-2.png": 1095,
	"./feedback-3.png": 1096,
	"./honor-pledge.png": 1097,
	"./icons/assignment-gray.png": 1098,
	"./icons/assignment.png": 1099,
	"./icons/dashboard-gray.png": 1100,
	"./icons/dashboard.png": 1101,
	"./icons/demo-gray.png": 1102,
	"./icons/demo.png": 1103,
	"./icons/quizzes-gray.png": 1104,
	"./icons/quizzes.png": 1105,
	"./icons/school-gray.png": 1106,
	"./icons/school.png": 1107,
	"./icons/standards-gray.png": 1108,
	"./icons/standards.png": 1109,
	"./icons/students-gray.png": 1110,
	"./icons/students.png": 1111,
	"./onboarding-book-reviews.png": 1112,
	"./onboarding-critical-thinking.png": 1113,
	"./onboarding-daily-reading.png": 1114,
	"./onboarding-fill-in-and-short-answer.png": 1115,
	"./onboarding-fill-in-only.png": 1116,
	"./onboarding-short-answer-in-only.png": 1117,
	"./onboarding-track-goals.png": 1118,
	"./onboarding-who-read.png": 1119,
	"./onboarding-writing-skills.png": 1120,
	"./owlfonso-waving.png": 1121,
	"./practice-question-1.png": 1122,
	"./practice-question-2.png": 1123,
	"./practice-question-3.png": 1124,
	"./profile-action-buttons.png": 1125,
	"./quiz-1.png": 1126,
	"./quiz-2.png": 1127,
	"./quiz-3.png": 1128,
	"./quotes.png": 1129,
	"./student-owl.png": 318,
	"./teacher-owl.png": 319
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 370;



//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding .\.png*
// module id = 370
// module chunks = 0